<script setup>
import { useAppStore } from '@/stores/App'

const app = useAppStore()
const staticURLImg = useRuntimeConfig().public.staticURLImg
const lightBox = ref(null)
</script>

<template>
    <v-row id="kontakt" class="justify-center bg-grey-darken-4 slide-from-left rounded">
        <!-- <v-col cols="12" class="pb-0 text-h4 text-sm-h3 text-center font-weight-medium st-text-shadow">
            Kontakt UI
        </v-col>
        <v-col cols="12" class="pt-0 text-center font-weight-medium st-text-shadow">
            Click an image to open the gallery.
        </v-col> -->
        <v-col cols="12" class="mt-16">
            <app-section-header
                :id="`kontaktui`"
                :title="`Kontakt UI Design`"
                :subtitle="`Click an image to open the gallery`"
            />
        </v-col>
        <v-col cols="8" class="mb-16 pa-0 pa-sm-2">
            <v-row dense class="rounded bg-grey-darken-4">
                <template v-for="(design, n) in app.kontaktDesigns" :key="design.alt">
                    <v-col :cols="design.cols">
                        <v-img
                            id="cardImg"
                            :src="staticURLImg + design.source"
                            height="100%"
                            cover
                            class="rounded"
                            :alt="design.alt"
                            @click.stop="lightBox.open(n)"
                        ></v-img>
                    </v-col>
                </template>
            </v-row>
            <the-lightbox ref="lightBox" :data="app.kontaktDesigns" />
        </v-col>
    </v-row>
</template>

<style scoped></style>
